import { useEffect } from "react";

// Reveals every <section> with a fade + slide-up as it scrolls into view.
// Renders nothing — it just wires up one IntersectionObserver for the page.
// Fully respects prefers-reduced-motion (content shows immediately, no motion).
const ScrollReveal = () => {
  useEffect(() => {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    const sections = Array.from(document.querySelectorAll("section"));
    if (!sections.length) return;

    if (prefersReduced) {
      sections.forEach((s) => s.classList.add("in-view"));
      return;
    }

    sections.forEach((s) => s.classList.add("reveal-init"));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  return null;
};

export default ScrollReveal;
